var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "row" }, [
      !_vm.batch_mode_active
        ? _c("div", { staticClass: "col-sm-6" }, [
            _vm.study_count < _vm.max_studies
              ? _c(
                  "div",
                  [
                    _c("tabix-adder", {
                      attrs: { allow_ld: _vm.study_count > 0 },
                      on: {
                        ready: _vm.receiveTabixReader,
                        fail: _vm.showMessage,
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.batch_mode_active
        ? _c(
            "div",
            { staticClass: "col-sm-6" },
            [
              _vm.study_count
                ? _c(
                    "div",
                    { staticClass: "d-flex justify-content-end" },
                    [
                      _c("region-picker", {
                        attrs: {
                          genome_build: _vm.genome_build,
                          max_range: _vm.max_region_size,
                          search_url:
                            "https://portaldev.sph.umich.edu/api/v1/annotation/omnisearch/",
                        },
                        on: { ready: _vm.selectRange, fail: _vm.showMessage },
                      }),
                      _vm._v(" "),
                      _c("batch-spec", {
                        staticClass: "ml-1",
                        attrs: { max_range: _vm.max_region_size },
                        on: { ready: _vm.activateBatchMode },
                        scopedSlots: _vm._u(
                          [
                            _vm.batch_region_getter
                              ? {
                                  key: "preset-button",
                                  fn: function (ref) {
                                    var updateRegions = ref.updateRegions
                                    return [
                                      _c(
                                        "button",
                                        {
                                          staticClass: "btn btn-warning",
                                          on: {
                                            click: function ($event) {
                                              updateRegions(
                                                _vm.batch_region_getter()
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("Get top hits")]
                                      ),
                                    ]
                                  },
                                }
                              : null,
                          ],
                          null,
                          true
                        ),
                      }),
                    ],
                    1
                  )
                : _c(
                    "b-dropdown",
                    {
                      staticClass: "float-right",
                      attrs: { text: "Genome Build", variant: "info" },
                    },
                    [
                      _c("div", { staticClass: "px-3" }, [
                        _c("div", { staticClass: "form-check" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.i_genome_build,
                                expression: "i_genome_build",
                              },
                            ],
                            staticClass: "form-check-input",
                            attrs: {
                              id: "build-37",
                              type: "radio",
                              name: "genome_build",
                              value: "GRCh37",
                            },
                            domProps: {
                              checked: _vm._q(_vm.i_genome_build, "GRCh37"),
                            },
                            on: {
                              change: function ($event) {
                                _vm.i_genome_build = "GRCh37"
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "form-check-label",
                              attrs: { for: "build-37" },
                            },
                            [_vm._v("GRCh37")]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-check" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.i_genome_build,
                                expression: "i_genome_build",
                              },
                            ],
                            staticClass: "form-check-input",
                            attrs: {
                              id: "build-38",
                              type: "radio",
                              name: "genome_build",
                              value: "GRCh38",
                            },
                            domProps: {
                              checked: _vm._q(_vm.i_genome_build, "GRCh38"),
                            },
                            on: {
                              change: function ($event) {
                                _vm.i_genome_build = "GRCh38"
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "form-check-label",
                              attrs: { for: "build-38" },
                            },
                            [_vm._v("GRCh38")]
                          ),
                        ]),
                      ]),
                    ]
                  ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.batch_mode_active
        ? _c(
            "div",
            { staticClass: "col-md-12" },
            [
              _c("batch-scroller", {
                attrs: { regions: _vm.batch_mode_regions },
                on: {
                  navigate: _vm.selectRange,
                  cancel: function ($event) {
                    _vm.batch_mode_active = false
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.message
        ? _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-sm-12" }, [
              _c("span", { class: [_vm.message_class] }, [
                _vm._v(_vm._s(_vm.message)),
              ]),
            ]),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }